import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable"
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDeletePatient } from "../hooks/useGetDataQuery";
import { Button } from "primereact/button";
import { useToastContext } from "../Lib/Contexts/toastContext";

const PatientTable = ({ patientList, patientListCount, lazyParamsForPatientList, setLazyParamsForPatientList, t, mode, setPatientNewList }: any) => {

    const {
        mutate: deleteNewPatientMutation,
        isSuccess: isSuccessdeleteNewPatient,
    } = useDeletePatient();


    const { showToast } = useToastContext();
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState(null);
    const [selectedRow, setSelectedRow] = useState<any>();
    const [deletePatient, setDeletePatient] = useState<any>();

    const columns = [
        {
            field: "firstName",

        },
        {
            field: "lastName",

        },
        {
            field: "dateCreated",

        },
        {
            field: "code"
        },
        {
            field: "action"
        },
        {
            field: "lastVisitDate"
        }
    ];

    useEffect(() => {
        if (isSuccessdeleteNewPatient) {
            showToast({
                severity: "success",
                summary: t("success"),
                detail: t("pateintDeleted"),
            });
            setPatientNewList((prevList: any) =>
                prevList.filter((patient: any) => patient.id !== deletePatient.id)
            );
            setDeletePatient(null);
        }
    }, [isSuccessdeleteNewPatient]);

    useEffect(() => {
        if (searchValue !== null) {
            const handler = setTimeout(() => {
                setLazyParamsForPatientList((prev: any) => ({
                    ...prev,
                    page: 0,
                    first: 0,
                    filters: {
                        ...prev.filters,
                        name: {
                            ...prev.filters.name,
                            value: searchValue,
                        },
                    },
                }));
            }, 500);
            return () => {
                clearTimeout(handler);
            };
        }
    }, [searchValue]);

    const onPage = (e: any) => {
        setLazyParamsForPatientList(e);
    }

    const onSort = (e: any) => {
        e["page"] = lazyParamsForPatientList.page
        setLazyParamsForPatientList(e);
    };

    const dateBody = (rowData: any) => {
        if (rowData.dateCreated) {
            const formattedDate = rowData.dateCreated.toLocaleDateString("tr-TR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            return formattedDate.replace(", ", " ")
        }
        else {
            return "-"
        };
    }

    const accessCodeBody = (rowData: any) => {
        if (rowData.code) {
            return rowData.code
        }
        else {
            return "-"
        };
    }
    const deletenewPatient = (patient: any) => {
        setDeletePatient(patient)
        deleteNewPatientMutation(patient.id)
    }

    const actionBody = (rowData: any) => {
        return (
            <Button
                icon={<img src="/redTrashIcon.svg" />}
                style={{
                    border: "none",
                    backgroundColor: "#FCEEF0",
                    borderRadius: "10px",
                    width: "2rem",
                    height: "2rem"
                }}
                onClick={() => { deletenewPatient(rowData) }}
                loading={deletePatient?.id === rowData?.id}
            >

            </Button>
        )
    }

    const lastVisitDateBody = (dateString: any) => {
        if (!dateString.lastVisitDate) return "---";

        const date = new Date(dateString.lastVisitDate);
        if (isNaN(date.getTime())) return "---";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    const viewPatientDetails = (rowData: any) => {
        setSelectedRow(rowData)
        localStorage.setItem("patient", JSON.stringify(rowData));
        navigate({ pathname: "/mobithera/prescription" })
    }

    const header = () => {
        return (
            <div className="flex justify-content-between align-items-center">
                <p className='text-xl' style={{ color: "#727A99" }}>
                    {mode === "newPatient" ? t("newPatientTableHeader") : t("patientTableHeader")}
                </p>
                <IconField iconPosition="left" className='w-20rem' >
                    <InputIcon className="pi pi-search" />
                    <InputText className='w-full' style={{ borderRadius: "10px" }} value={searchValue}
                        onChange={(e: any) => setSearchValue(e.target.value)} placeholder={t("datatableSearchPlaceholder")} />
                </IconField>
            </div>
        );
    };

    const dynamicColumns = columns.map((col: any) => {
        if (col.field === "firstName") {
            return (
                <Column
                    key="firstName"
                    field={col.field}
                    header={t(col.field)}
                    dataType='text'
                    sortable
                />
            );
        }
        else if (col.field === "lastName") {
            return (
                <Column
                    key="lastName"
                    field={col.field}
                    header={t(col.field)}
                    dataType='text'
                    sortable
                />
            );
        }
        else if (col.field === "dateCreated") {
            return (
                <Column
                    key="dateCreated"
                    field={col.field}
                    header={t(col.field)}
                    dataType='date'
                    body={dateBody}
                    sortable
                />
            );
        }
        else if (col.field === "code") {
            return (
                <Column
                    key="code"
                    field={col.field}
                    header={t("registerCode")}
                    dataType='text'
                    body={accessCodeBody}
                />
            );
        }
        else if (col.field === "action" && mode === "newPatient") {
            return (
                <Column
                    key="action"
                    field={col.field}
                    header={t("action")}
                    body={actionBody}
                />
            );
        }
        else if (col.field === "lastVisitDate" && mode !== "newPatient") {
            return (
                <Column
                    key="lastVisitDate"
                    field={col.field}
                    sortable
                    header={t("lastVisitDate")}
                    body={lastVisitDateBody}
                />
            );
        }
    });

    return (
        <>
            <DataTable
                className="patients-table"
                value={patientList}
                lazy
                paginator
                first={lazyParamsForPatientList.first}
                rows={lazyParamsForPatientList.rows}
                totalRecords={patientListCount}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                currentPageReportTemplate={`${t("totalOf")} ${patientListCount ? patientListCount : 0} ${t("totalOfPatient")}`}
                onPage={onPage}
                onSort={onSort}
                sortField={lazyParamsForPatientList.sortField}
                sortOrder={lazyParamsForPatientList.sortOrder}
                filters={lazyParamsForPatientList.filters}
                header={header}
                selectionMode="single"
                selection={selectedRow}
                onSelectionChange={(e) => viewPatientDetails(e.value)}
            >
                {dynamicColumns}
            </DataTable>
        </>
    )
}

export default PatientTable

